<template>
 <!-- mcf-light/mcf-dark 切換日夜模式-->
  <div :class="layoutType">
    <slot name="MainView"></slot>
    <div class="container-fluid" style="max-width: 1140px;">
      <div class="row no-gutters" style="min-height: calc(100vh - 240px);">
        <div class="col-4 mcf-bg">
          <slot name="MainInfo"></slot>
        </div>
        <div class="col-8">
          <slot name="IndexContent"></slot>
          <router-view/>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapState(['layoutType']),
  },
  created() {
    const vm = this;
    vm.$store.dispatch('getPageSetting', 'MemberCentreHomePage');
  },
};
</script>
